module.exports = __webpack_public_path__ + "static/media/QR_feishu.d02e03cc.png";